// extracted by mini-css-extract-plugin
module.exports = {"backgroundImageWrapper":"CustomAppearance_backgroundImageWrapper__3gX9F","backgroundImage":"CustomAppearance_backgroundImage__14lBs"};